<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

defineProps({
  modelValue: { type: String, required: true },
});

const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();
const items = computed(() => [
  {
    key: 'all',
    label: t('CHAT_LIST.QUICK_FILTERS.ALL'),
    icon: 'i-lucide-messages-square',
    iconClass: 'text-n-slate-11',
  },
  {
    key: 'whatsapp',
    label: 'WhatsApp',
    icon: 'i-ri-whatsapp-fill',
    iconClass: 'text-[#25D366]',
  },
  {
    key: 'instagram',
    label: 'Instagram',
    icon: 'i-ri-instagram-fill',
    iconClass: 'text-[#E4405F]',
  },
  {
    key: 'messenger',
    label: 'Messenger',
    icon: 'i-ri-messenger-fill',
    iconClass: 'text-[#0084FF]',
  },
  {
    key: 'email',
    label: 'Correos',
    icon: 'i-lucide-mail',
    iconClass: 'text-[#EA4335]',
  },
  {
    key: 'comments',
    label: 'Comentarios',
    icon: 'i-ri-instagram-fill',
    iconClass: 'text-[#E4405F]',
    facebookIcon: 'i-ri-facebook-circle-fill',
  },
  {
    key: 'comments_archive',
    label: 'Archivo comentarios',
    icon: 'i-lucide-archive',
    iconClass: 'text-n-slate-11',
  },
  {
    key: 'unanswered',
    label: t('CHAT_LIST.QUICK_FILTERS.UNANSWERED'),
    icon: 'i-lucide-message-circle-question',
    iconClass: 'text-n-amber-9',
  },
  {
    key: 'changes',
    label: t('CHAT_LIST.QUICK_FILTERS.CHANGES'),
    icon: 'i-lucide-refresh-cw',
    iconClass: 'text-n-slate-11',
  },
]);
</script>

<template>
  <div
    class="w-full min-w-0 flex-none overflow-hidden border-b border-n-weak bg-n-surface-1 px-2 pb-2 sm:px-3"
  >
    <nav
      class="grid w-full min-w-0 grid-cols-2 gap-1.5 min-[430px]:grid-cols-3 sm:flex sm:flex-wrap"
      :aria-label="t('CHAT_LIST.QUICK_FILTERS.LABEL')"
    >
      <button
        v-for="item in items"
        :key="item.key"
        type="button"
        class="flex h-8 min-w-0 items-center justify-center gap-1.5 rounded-full border px-2 text-xs font-medium transition-colors sm:flex-none sm:px-3"
        :class="
          modelValue === item.key
            ? 'border-n-slate-12 bg-n-slate-12 text-n-slate-1'
            : 'border-n-weak bg-n-alpha-1 text-n-slate-11 hover:bg-n-alpha-2'
        "
        :aria-pressed="modelValue === item.key"
        @click="emit('update:modelValue', item.key)"
      >
        <span v-if="item.facebookIcon" class="flex flex-none -space-x-0.5">
          <Icon
            :icon="item.icon"
            class="size-3.5"
            :class="modelValue === item.key ? 'text-current' : item.iconClass"
          />
          <Icon
            :icon="item.facebookIcon"
            class="size-3.5"
            :class="
              modelValue === item.key ? 'text-current' : 'text-[#1877F2]'
            "
          />
        </span>
        <Icon
          v-else
          :icon="item.icon"
          class="size-4 flex-none"
          :class="modelValue === item.key ? 'text-current' : item.iconClass"
        />
        <span class="min-w-0 truncate">{{ item.label }}</span>
      </button>
    </nav>
  </div>
</template>
